import { render, staticRenderFns } from "./Userinfo.vue?vue&type=template&id=2932d717&scoped=true&"
import script from "./Userinfo.vue?vue&type=script&lang=js&"
export * from "./Userinfo.vue?vue&type=script&lang=js&"
import style0 from "./Userinfo.vue?vue&type=style&index=0&id=2932d717&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2932d717",
  null
  
)

export default component.exports